import { ColorPaletteDto } from 'webcommon/shared';

export const ColorPalette: ColorPaletteDto[] = [
  { name: 'Purple', hexCode: '#7733A3' },
  { name: 'Lavender', hexCode: '#C39BD3' },
  { name: 'Fucsia', hexCode: '#BA5FA6' },
  { name: 'Pink', hexCode: '#FAA5C2' },
  { name: 'Salmon', hexCode: '#FD7456' },
  { name: 'Orange', hexCode: '#FFAD46' },
  { name: 'Gold', hexCode: '#FFD51E' },
  { name: 'Light Turquoise', hexCode: '#A2D9CE' },
  { name: 'Turquoise', hexCode: '#36AA9F' },
  { name: 'Periwinkle', hexCode: '#59A4FB' },
  { name: 'Dark Blue', hexCode: '#4475C5' },
  { name: 'Light Purple', hexCode: '#C1CAFF' },
  { name: 'Yellow', hexCode: '#FFF098' },
  { name: 'Red', hexCode: '#DC2A2A' },
  { name: 'Dark Orange', hexCode: '#EE6723' },
  { name: 'Black', hexCode: '#303132' },
];
